import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";

export function ThemeToggle({ size = "icon" }) {
  const { theme, toggle } = useTheme();
  return (
    <Button
      variant="ghost"
      size={size}
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className="rounded-full hover:bg-primary/10"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
